import { render, staticRenderFns } from "./CustomerDetailsItemView.vue?vue&type=template&id=5c2d5a3c&"
import script from "./CustomerDetailsItemView.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsItemView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2d5a3c')) {
      api.createRecord('5c2d5a3c', component.options)
    } else {
      api.reload('5c2d5a3c', component.options)
    }
    module.hot.accept("./CustomerDetailsItemView.vue?vue&type=template&id=5c2d5a3c&", function () {
      api.rerender('5c2d5a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/CustomerDetailsItemView.vue"
export default component.exports